import { isRelation } from '../../core/decorators/relation.decorator';

export function camelToKebab(str: string) {
  return str.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toJsonApi(resourceType: string, entity: any): any {
  const { id, ...rest } = entity;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const attributes: Record<string, any> = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const relationships: Record<string, any> = {};

  for (const key in rest) {
    const value = rest[key];

    if (isRelation(entity, key)) {
      if (Array.isArray(value)) {
        relationships[key] = {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          data: value.map((v: any) => ({ type: v.type || camelToKebab(key), id: v.id }))
        };
      }
      else if (value && typeof value === 'object' && 'id' in value) {
        relationships[key] = {
          data: { type: value.type || camelToKebab(key), id: value.id }
        };
      }
      else {
        relationships[key] = { data: null };
      }
    }
    else {
      attributes[key] = value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const jsonApi: any = { data: { type: resourceType, attributes } };
  if (id) jsonApi.data.id = id;
  if (Object.keys(relationships).length) {
    jsonApi.data.relationships = relationships;
  }

  return jsonApi;
}
